import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=4dd8f7f8&scoped=true&"
import script from "./Hero.vue?vue&type=script&setup=true&lang=js&"
export * from "./Hero.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Hero.vue?vue&type=style&index=0&id=4dd8f7f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd8f7f8",
  null
  
)

export default component.exports